import styled from 'styled-components';

import colors from 'styleguide/colors';

export const Shortcut = styled.span`
  border: 1px solid ${colors('black')};
  border-radius: 0.25em;

  padding: 8px;
  margin-right: 4px;

  min-width: 32px;
  height: 32px;

  font-size: 14px;
  line-height: 1.2em;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  ${({ rotate }: { rotate?: string }) => rotate && `transform: rotate(${rotate}deg);`}
`;
